import { Button as RACButton } from 'react-aria-components';

import { Icon } from '../../assets/Icon/Icon';
import {
  secondaryDisabledStyles,
  secondaryEnabledStyles,
} from '../../controls/Button/ButtonStyles';
import { selectors, transitions } from '../../controls/shared/styles';
import { colors, darkThemeSelector, shadows, styled } from '../../stitches.config';

export const selectArrowsColor = '$$selectArrowsColor';
export const selectIconColor = '$$selectIconColor';

export const SelectContainer = styled('div', {
  width: 'min-content',
  minWidth: 0,
});

export const SelectArrows = styled(Icon, {
  color: selectArrowsColor,
});

export const SelectTrigger = styled(RACButton, {
  position: 'relative',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  gap: '$$buttonGap',
  paddingX: '$$paddingX',
  paddingY: '$$paddingY',
  opacity: 1,
  backgroundColor: '$white',
  truncate: true,
  whiteSpace: 'nowrap',
  cursor: 'pointer',
  userSelect: 'none',
  transition: transitions.control,

  [selectors.focus]: {
    outline: 'none',
  },

  [darkThemeSelector]: {
    background: '$gray800',
  },

  variants: {
    size: {
      'x-small': {
        minHeight: '$20',
        borderRadius: '$6',

        $$buttonGap: '$space$2',
        $$paddingX: '$space$4',
        $$paddingY: '$space$2',
        $$iconSize: '$space$12',
      },
      small: {
        '@notDesktop': {
          minHeight: '$28',
          borderRadius: '$10',

          $$buttonGap: '$space$6',
          $$paddingX: '$space$8',
          $$paddingY: '$space$2',
          $$iconSize: '$space$14',
        },

        '@desktop': {
          minHeight: '$24',
          borderRadius: '$8',

          $$buttonGap: '$space$4',
          $$paddingX: '$space$6',
          $$paddingY: '$space$2',
          $$iconSize: '$space$12',
        },
      },
      medium: {
        '@notDesktop': {
          minHeight: '$32',
          borderRadius: '$10',

          $$buttonGap: '$space$6',
          $$paddingX: '$space$10',
          $$paddingY: '$space$4',
          $$iconSize: '$space$14',
        },

        '@desktop': {
          minHeight: '$28',
          borderRadius: '$8',

          $$buttonGap: '$space$4',
          $$paddingX: '$space$8',
          $$paddingY: '$space$4',
          $$iconSize: '$space$12',
        },
      },
      large: {
        minHeight: '$36',
        borderRadius: '$10',

        $$buttonGap: '$space$6',
        $$paddingX: '$space$12',
        $$paddingY: '$space$4',
        $$iconSize: '$space$12',
      },
      'x-large': {
        minHeight: '$44',
        borderRadius: '$12',

        $$buttonGap: '$space$8',
        $$paddingX: '$space$20',
        $$paddingY: '$space$6',
        $$iconSize: '$space$12',
      },
    },
    isDisabled: {
      true: {
        cursor: 'not-allowed',
        opacity: 0.5,
        ...secondaryDisabledStyles,
      },
      false: {
        ...secondaryEnabledStyles,
      },
    },
    ghost: {
      true: {},
      false: {},
    },
    invalid: {
      true: {},
      false: {},
    },
  },
  compoundVariants: [
    {
      isDisabled: false,
      invalid: true,
      css: {
        boxShadow: shadows.fieldErrorLight,

        '&:hover:not(:focus)': {
          boxShadow: shadows.fieldErrorLight,
        },

        [darkThemeSelector]: {
          boxShadow: shadows.fieldErrorDark,

          '&:hover:not(:focus)': {
            boxShadow: shadows.fieldErrorDark,
          },
        },
      },
    },

    // Ghost
    {
      ghost: true,
      css: {
        '&[data-ghost="true"]:not(:hover, :focus, :focus-visible, :focus-within)': {
          backgroundColor: colors.transparent,
          boxShadow: colors.transparent,
        },
      },
    },
  ],
});
